// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"2a0225f9","223":"a4dbf874","782":"125ffe7f"}[chunkId] + ".chunk.js";
};